const STORAGE_KEY = 'cvgidas_saved_searches';
const SUBSCRIPTION_KEY = 'cvgidas_subscriptions';

export type LocalSavedSearch = {
  id: string;
  name: string;
  keywords: string[];
  location: string[];
  work_field: string[];
  job_type: string[];
  work_time: string[];
  salary_min: number | null;
  created_at: string;
};

export type LocalSubscription = {
  id: string;
  name: string;
  email: string;
  frequency: 'daily' | 'weekly';
  keywords: string[];
  location: string[];
  work_field: string[];
  job_type: string[];
  work_time: string[];
  salary_min: number | null;
  created_at: string;
  enabled: boolean;
};

// --- Saved Searches ---

export function getLocalSavedSearches(): LocalSavedSearch[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function addLocalSavedSearch(
  search: Omit<LocalSavedSearch, 'id' | 'created_at'>
): LocalSavedSearch {
  const entry: LocalSavedSearch = {
    ...search,
    id: crypto.randomUUID(),
    created_at: new Date().toISOString(),
  };
  try {
    const list = getLocalSavedSearches();
    list.push(entry);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch { /* localStorage unavailable */ }
  return entry;
}

export function updateLocalSavedSearch(
  id: string,
  updates: Partial<LocalSavedSearch>
): void {
  try {
    const list = getLocalSavedSearches();
    const idx = list.findIndex((s) => s.id === id);
    if (idx !== -1) {
      list[idx] = { ...list[idx], ...updates };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    }
  } catch { /* localStorage unavailable */ }
}

export function deleteLocalSavedSearch(id: string): void {
  try {
    const list = getLocalSavedSearches().filter((s) => s.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch { /* localStorage unavailable */ }
}

export function clearLocalSavedSearches(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch { /* localStorage unavailable */ }
}

// --- Subscriptions ---

export function getLocalSubscriptions(): LocalSubscription[] {
  try {
    const raw = localStorage.getItem(SUBSCRIPTION_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function addLocalSubscription(
  sub: Omit<LocalSubscription, 'id' | 'created_at'>
): LocalSubscription {
  const entry: LocalSubscription = {
    ...sub,
    id: crypto.randomUUID(),
    created_at: new Date().toISOString(),
  };
  try {
    const list = getLocalSubscriptions();
    list.push(entry);
    localStorage.setItem(SUBSCRIPTION_KEY, JSON.stringify(list));
  } catch { /* localStorage unavailable */ }
  return entry;
}

export function updateLocalSubscription(
  id: string,
  updates: Partial<LocalSubscription>
): void {
  try {
    const list = getLocalSubscriptions();
    const idx = list.findIndex((s) => s.id === id);
    if (idx !== -1) {
      list[idx] = { ...list[idx], ...updates };
      localStorage.setItem(SUBSCRIPTION_KEY, JSON.stringify(list));
    }
  } catch { /* localStorage unavailable */ }
}

export function deleteLocalSubscription(id: string): void {
  try {
    const list = getLocalSubscriptions().filter((s) => s.id !== id);
    localStorage.setItem(SUBSCRIPTION_KEY, JSON.stringify(list));
  } catch { /* localStorage unavailable */ }
}
